/**
 * @class Step
 */
export default class Step {
    /**
     * @param {Number}  index
     * @param {String}  name
     * @param {Boolean} available
     * @param {Boolean} completed
     * @param {Boolean} visited
     * @param {Number}  stepNumber
     * @param {Number}  numberOfSteps
     */
    constructor(index, name, available, completed, visited, stepNumber = 1, numberOfSteps = 1) {
        this._index = index;
        this._name = name;
        this._available = available;
        this._completed = completed;
        this._visited = visited;
        this._stepNumber = stepNumber;
        this._numberOfSteps = numberOfSteps;
    }

    /**
     * @return {Number}
     */
    get index() {
        return this._index;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @return {Boolean}
     */
    get available() {
        return this._available;
    }

    /**
     * @return {Boolean}
     */
    get completed() {
        return this._completed;
    }

    /**
     * @return {Boolean}
     */
    get visited() {
        return this._visited;
    }

    /**
     * @return {Number}
     */
    get stepNumber() {
        return this._stepNumber;
    }

    /**
     * @param {Number} numberOfSteps
     */
    set numberOfSteps(numberOfSteps) {
        this._numberOfSteps = numberOfSteps;
    }

    /**
     * @return {Number}
     */
    get numberOfSteps() {
        return this._numberOfSteps;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new Step(
            this._index,
            this._name,
            this._available,
            this._completed,
            this._visited,
            this._stepNumber,
            this._numberOfSteps
        );
    }

    /**
     * @param {Number}  index
     * @return {Object}
     */
    updateIndex = (index) => {
        let step = this.clone();
        step._index = index;

        return step;
    };

    /**
     * @param   {Boolean}   available
     * @return  {Object}
     */
    updateAvailable = (available) => {
        let step = this.clone();
        step._available = available;
        step._completed = false;

        return step;
    };

    /**
     * @return {Object}
     */
    updateCompleted = () => {
        let step = this.clone();
        step._available = true;
        step._completed = true;

        return step;
    };

    /**
     * @param   {Boolean}   visited
     * @return  {Object}
     */
    updateVisited = (visited) => {
        let step = this.clone();
        step._visited = visited;

        return step;
    };

    /**
     * @return {Object}
     */
    nextStep = () => {
        let step = this.clone();
        step._stepNumber = this.stepNumber + 1;

        return step;
    };

    /**
     * @return {Object}
     */
    previousStep = () => {
        let step = this.clone();
        step._stepNumber = this.stepNumber - 1;

        return step;
    };

    increaseNumberOfSteps = () => {
        this._numberOfSteps++;
    };
}
